import React from "react";
import "../../pages/doctor-console/DoctorConsole.scss";
import {
  Modal,
  Box,
  Typography,
  Button as muiButton,
  IconButton,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
import { Row, Col } from "../../components/RowCol";
import { Table, Button } from "react-bootstrap";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { Icon, TableHead } from "@mui/material";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useState } from "react";
import HiTypeHeader from "../../pages/doctor-console/Utils/HiTypeHeader";
import { separateCamelCase } from "../../pages/doctor-console/Utils/UtilsFunctions";
import { DoctorconsoleGrid } from "../../pages/doctor-console/StyledComponents";
import { AttachmentActionButtons, ModalActionButtons } from "../../pages/doctor-console/Utils/AttachmentActions";

const Wellness = (props) => {
  const [resArr, setResArr] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const wellnessData = props.wellnessData;
  console.log("Wellness page data", wellnessData);
  function formatDateString(dateString) {
    const isoDateFormatRegex =
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/;

    if (isoDateFormatRegex.test(dateString)) {
      // Convert ISO 8601 format to YYYY-MM-DD format
      const date = new Date(dateString);
      return date.toISOString().split("T")[0];
    } else {
      // Date is already in YYYY-MM-DD format; no need to change it
      return dateString;
    }
  }

  const viewAttachment = (attach) => {
    // console.log(attachment);
    let attachment = attach.content[0];
    setCurrentAttachment(attachment);
    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (attachment.content_type === "application/pdf") {
      const url = `data:application/pdf;base64,${attachment.data}#toolbar=0`;
      modalContent = (
        <iframe width="100%" height="100%" src={url} title={attach.id}></iframe>
      );
    } else if (
      attachment.content_type === "image/jpeg" ||
      attachment.content_type === "image/jpg" ||
      attachment.content_type === "image/png"
    ) {
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt={attach.id} title={attach.id} />
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setModalContent(modalContent);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent(null);
    setCurrentAttachment(null);
  };

  useEffect(() => {
    // if (
    //   props.data.entry !== null &&
    //   props.data.entry !== undefined &&
    //   props.data.entry.length > 0
    // ) {
    //   console.log("Set is done");
    //   setResArr(props.data.entry);
    // }
  }, []);
  // console.log("result arr length", resArr.length);
  return (
    <>
      <DoctorconsoleGrid>
        {wellnessData !== null && wellnessData !== undefined ? (
          <>
            <HiTypeHeader
              date={wellnessData.Date}
              name={"Wellness Record"}
              encounter={wellnessData.Encounter}
              organizationDetails={wellnessData.Organization}
              practitionerDetails={wellnessData.Practitioner}
            />
            {Object.keys(wellnessData).map(
              (categoryKey) =>
                ![
                  "Encounter",
                  "Date",
                  "Organization",
                  "Practitioner",
                  "Patient",
                ].some(
                  (substring) =>
                    substring === categoryKey.match(/\(([^)]+)\)/)?.[1] ||
                    substring == categoryKey // Extract and check in the same line
                ) && (
                  <Accordion className="innermost-accordion" defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      className="innermost-accordion-summary"
                    >
                      <Typography
                        sx={{ color: "white" }}
                        className="accordion-section-title"
                      >
                        {categoryKey}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {categoryKey.includes("DocumentReference") ? (
                        <div
                          style={{
                            marginTop: "20px",
                            fontWeight: "bold",
                            marginBottom: "50px",
                            fontSize: "16px",
                          }}
                        >
                          Attachments :{" "}
                          {wellnessData[categoryKey].length > 0
                            ? wellnessData[categoryKey].map((attachment, attIdx) => (
                                <span key={attIdx} style={{ display: "inline-flex", alignItems: "center", gap: "4px", marginRight: "12px" }}>
                                  <button style={{backgroundColor: "#007bff", color: "#fff", border: "none", padding: "5px 10px", cursor: "pointer"}} onClick={() => viewAttachment(attachment)} title={attachment.id}>
                                    <i className="fas fa-file"></i>
                                  </button>
                                  <AttachmentActionButtons base64Data={attachment?.content?.[0]?.data} contentType={attachment?.content?.[0]?.content_type} filename={attachment?.id || "attachment"} />
                                </span>
                              ))
                            : "No attachments found!"}
                        </div>
                      ) : wellnessData[categoryKey]?.length > 0 ? (
                        <Row
                          style={{
                            marginTop: "30px",
                          }}
                        >
                          <Col
                            area="span 12"
                            style={{ border: "2px solid #ebf5f4" }}
                          >
                            <Table responsive size="lg">
                              <TableHead
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  gridTemplateColumns:
                                    "250px 250px 250px 120px 120px",
                                  justifyContent: "center",
                                }}
                              >
                                <td>Title</td>
                                <td>Value</td>
                                <td>Unit</td>
                                <td>Notes</td>
                                <td>Status</td>
                              </TableHead>
                              <tbody>
                                {wellnessData[categoryKey].map(
                                  (observationObj, ind) => (
                                    <tr key={ind}>
                                      <td>
                                        {observationObj?.code &&
                                        observationObj.code.length > 0
                                          ? observationObj.code[
                                              observationObj.code.length - 1
                                            ].text ||
                                            observationObj.code[
                                              observationObj.code.length - 1
                                            ].display ||
                                            "-"
                                          : "-"}
                                      </td>

                                      <td>
                                        {observationObj &&
                                        observationObj.value_quantity &&
                                        Object.keys(
                                          observationObj.value_quantity
                                        ).length > 0
                                          ? observationObj.value_quantity
                                              .value !== undefined
                                            ? observationObj.value_quantity
                                                .value
                                            : observationObj.value_quantity
                                                .string ||
                                              observationObj.value_quantity
                                                .value_text ||
                                              observationObj.value_quantity
                                                .value_datetime
                                          : "-"}
                                      </td>

                                      <td>
                                        {observationObj?.value_quantity?.unit?.trim() ||
                                          "-"}
                                      </td>

                                      <td>
                                        {observationObj?.note &&
                                        observationObj?.note.length > 0
                                          ? observationObj?.note?.[0].text
                                          : "-"}
                                      </td>
                                      <td>
                                        {observationObj &&
                                          observationObj.status}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      ) : (
                        <div
                          style={{
                            marginTop: "20px",
                            padding: "10px",
                            backgroundColor: "#3AC8BA",
                            fontWeight: "bold",
                            fontSize: "18px",
                          }}
                        >
                          No Observations found!
                        </div>
                      )}
                    </AccordionDetails>
                  </Accordion>
                )
            )}
          </>
        ) : (
          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              backgroundColor: "#3AC8BA",
              fontWeight: "bold",
              fontSize: "25px",
            }}
          >
            No Wellness Data found!
          </div>
        )}
      </DoctorconsoleGrid>

      <Helmet>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
          crossorigin="anonymous"
        />
      </Helmet>
      <Modal open={showModal} onClose={closeModal}>
        <Box className="modal-box">
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "4px", padding: "8px 12px", borderBottom: "1px solid #e0e0e0" }}>
            {currentAttachment && (
              <ModalActionButtons base64Data={currentAttachment.data} contentType={currentAttachment.content_type} filename="attachment" />
            )}
            <IconButton onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>
          {/* <Typography variant="h6">PDF Viewer</Typography> */}

          <div style={{ flex: 1 }}>{modalContent}</div>
        </Box>
      </Modal>
    </>
  );
};
const datapoints = [20, 50, 30, 20, 35, 40, 30, 20, 40, 30];
const state = {
  labels: [
    "Jan-2021",
    "Feb-2021",
    "Mar-2021",
    "Apr-2021",
    "May-2021",
    "Jun-2021",
    "Jul-2021",
    "Aug-2021",
    "Sep-2021",
  ],
  datasets: [
    {
      //label: 'Cubic interpolation (monotone)',
      label: "WBC Count",
      data: datapoints,
      //borderColor: 'rgba(255, 0, 0)',
      borderColor: "rgba(51, 0, 0, 0.8)",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderWidth: 1.5,
      fill: false,
      //cubicInterpolationMode: 'monotone',
      tension: 0,
    },
    /*, {
        label: 'Cubic interpolation',
        data: datapoints,
        borderColor: 'rgba(0, 0, 255)',
        borderWidth: 1.5,
        fill: false,
        tension: 0.4
    }, {
        label: 'Linear interpolation (default)',
        data: datapoints,
        borderColor: 'rgba(0, 128 ,0)',
        borderWidth: 1.5,
        fill: false
    }*/
  ],
};

const progressColors = {
  green: "#01A601",
  pink: "#E87971",
  blue: "#05C4E2",
  orange: "#F66220",
};

const Progress = styled.div`
  height: 0.6rem;
  background-color: #ccd0d2;
  display: grid;
  grid-template-columns: ${(props) => props.width} calc(
      100% - ${(props) => props.width}
    );
  border-radius: 50px;
  width: 100%;
  .progress-item {
    height: 0.6rem;
    background-color: ${({ color }) => progressColors[color]};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-radius: 50px;
    span {
      font-size: 0.8rem;
      color: #94999c;
      margin-top: -3rem;
    }
  }
  .bg {
    width: 100%;
  }
`;
const ProgressBar = ({ color, width }) => {
  return (
    <Progress color={color} width={width}>
      <div className="progress-item">
        <span>{width}</span>
      </div>
      <div className="bg"></div>
    </Progress>
  );
};
export default Wellness;
